<script>
export default {
	name: "Loading",
	props: {
		isActiveLoading: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		lightboxToggle() {
			// console.log("lightboxToggle")
			const _this = this;
			_this.$emit("update:isActiveLoading", false);
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@use "@/assets/sass/_variable.sass"
@use "@/assets/sass/_mixin.sass"
</style>
